<template>
  <div class="confirm-order-warpper order-card-page">
    <div v-if="showTopAddressHead" class="confirm-order-address-fixed">
      <div class="confirm-order-content">
        <order-head
          :readonly="addressHeadReadonly"
          :name="orderInfo.consigneeName"
          :tel="orderInfo.consigneePhone"
          :address="getDisplayAddress()"
          @EditAddress="editAddress"
        />
      </div>
    </div>
    <div class="confirm-order-scroll">
      <!-- 与订单详情一致：按配送组一张卡片，组内多条商品共用底部配送/门店等信息 -->
      <div v-for="(gBlock, gi) in displayProductGroups" :key="'pg-' + gi" class="order-card-wrap">
        <div class="bgc order-group-card">
          <div
            v-for="(item, ii) in gBlock.items"
            :key="'pi-' + gi + '-' + ii"
            :class="['product-group-segment', { 'is-not-first-product': ii > 0 }]"
          >
            <div class="product-head">
              <div>
                <img v-if="item.coverImage" :src="item.coverImage" alt="" class="img" />
              </div>
              <div class="product-body">
                <div class="product-main">
                  <span class="textTitle"> {{ item.productName }}</span>
                  <span class="textcontext product-spec"> {{ item.skuName }}</span>
                  <span class="textcontext product-taste" v-if="item.tastesName">口味：{{ item.tastesName }}</span>
                </div>
                <div class="product-price-col">
                  <div class="product-price-line" v-if="item.isShowPrice !== false">
                    <span class="product-amount">
                      {{ getPrice(1, item.showPrice) }}{{ orderInfo?.cardPointTypeUnit || '点' }}
                    </span>
                    <span class="product-qty">x{{ item.emptionNum }}</span>
                  </div>
                  <div class="product-price-line" v-else>
                    <span class="product-amount">&nbsp;</span>
                    <span class="product-qty">x{{ item.emptionNum }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="item.chargeDetails && item.chargeDetails.length" class="charge-list charge-list--bordered">
              <div class="charge-list-title">附件</div>
              <div class="charge-row" v-for="(c, ci) in item.chargeDetails" :key="ci">
                <span class="charge-name">{{ c.chargeName }}</span>
                <span class="charge-qty">×{{ c.quantity }}</span>
                <span class="charge-amount" v-if="item.isShowPrice !== false">
                  {{ formatChargeAmount(c.chargePrice) }}{{ orderInfo?.cardPointTypeUnit || '点' }}
                </span>
              </div>
              <div class="charge-row" v-if="item.isShowPrice !== false && item.chargeTotalAmount">
                <span class="charge-name" style="color:#888;">附件小计</span>
                <span class="charge-qty">&nbsp;</span>
                <span class="charge-amount" style="font-weight:600;">
                  {{ formatChargeAmount(item.chargeTotalAmount) }}{{ orderInfo?.cardPointTypeUnit || '点' }}
                </span>
              </div>
            </div>
            <div v-if="item.blessings" class="sendjcsb sendjcsb--padded bordered-top">
              <span class="label-muted">祝福语：</span>
              <span>{{ item.blessings }}</span>
            </div>
            <div v-if="item.buyerMsg" class="sendjcsb sendjcsb--padded">
              <span class="label-muted">备注：</span>
              <span>{{ item.buyerMsg }}</span>
            </div>
            <div v-if="item.rechargeAccount" class="sendjcsb sendjcsb--padded bordered-top">
              <span class="label-muted">充值账户：</span>
              <span>{{ item.rechargeAccount }}</span>
            </div>
            <div v-if="item.rechargeAccount" class="sendjcsb recharge-hint">
              <div>请仔细核对充值账户，若充值错误，将无法退回</div>
            </div>
          </div>

          <!-- 本组统一：不支持配送时仅在组底展示一次（有分组时多商品共用；无 groups 时每子单独立卡片，仍只在该卡片底部展示一次） -->
          <div class="group-delivery-block">
            <div v-if="groupDeliveryUnsupported(gBlock)" class="group-undeliverable-banner">
              <p class="group-undeliverable-title">该商品不支持配送</p>
            </div>
            <template v-if="!groupDeliveryUnsupported(gBlock) && !groupAllLogistic(gBlock)">
              <div class="sendjcsb sendjcsb--padded">
                <span class="label-muted">配送方式</span>
                <span>{{ getSendType0(groupFooterForDelivery(gBlock)) }}</span>
              </div>
              <div v-if="groupDeliveryText(gBlock)" class="group-delivery-note-under-method">
                {{ groupDeliveryText(gBlock) }}
              </div>
              <div
                v-if="(groupFooterForDelivery(gBlock).shipType && groupFooterForDelivery(gBlock).shipDate) || (groupFooterForDelivery(gBlock).ship_type && groupFooterForDelivery(gBlock).ship_date)"
                class="sendjcsb sendjcsb--padded"
              >
                <span class="label-muted">{{ getSendType1(groupFooterForDelivery(gBlock)) }}</span>
                <span>{{ getSendType2(groupFooterForDelivery(gBlock)) }}</span>
              </div>
              <div v-if="ifShoow(groupFooterForDelivery(gBlock))" class="sendjcsb sendjcsb--padded">
                <span class="label-muted label-muted--wide">门店名称</span>
                <span>{{ groupFooterForDelivery(gBlock).shopName || groupFooterForDelivery(gBlock).take_shop_name }}</span>
              </div>
              <div v-if="ifShoow(groupFooterForDelivery(gBlock))" class="sendjcsb sendjcsb--padded">
                <span class="label-muted label-muted--wide">门店地址</span>
                <span>{{ groupFooterForDelivery(gBlock).shopDetail || groupFooterForDelivery(gBlock).addr }}</span>
              </div>
              <div v-if="showGroupShipFeeRow(gBlock.group)" class="sendjcsb sendjcsb--padded">
                <span class="label-muted">运费</span>
                <span class="group-ship-fee-value">
                  <template v-if="gBlock.group && Number(gBlock.group.shipAmount) > 0">
                    <span class="text-fee">{{ formatShipAmount(gBlock.group.shipAmount) }}{{ orderInfo?.cardPointTypeUnit || '点' }}</span>
                  </template>
                  <template v-else>
                    <span class="text-free-ship">包邮</span>
                  </template>
                </span>
              </div>
            </template>
          </div>
        </div>
      </div>

      <div class="bgc order-summary-card">
        <div class="sendjcsb" style="border-top: 1px" v-if="!isLogisticOnly">
          <span style="color: #888;">{{ orderTotalShipLabel }}</span>
          <span v-if="orderInfo.postMoney && orderInfo.postMoney > 0">{{ orderInfo.postMoney }}{{ orderInfo?.cardPointTypeUnit || '点' }}</span>
          <span v-else>包邮</span>
        </div>
        <div class="sendjcsb" @click="selectScarce">
          <span style=" margin: 0.5rem 0; color: #888;min-width: 5rem;">如遇缺货</span>
          <span style=" margin: 0.5rem 0; "> 
            {{ scarceStr }} 
            <van-icon name="arrow" color="#999" />
          </span>
        </div>
        <div class="sendjcsb" style="border-top: 1px;justify-content:flex-end; border-top: 1px solid #ededed; margin-top: 0.5rem; ">
          <span style="font-size: 1rem;color: #666; margin: 0.5rem 0;">合计:</span>
          <span style="font-size: 1rem; font-weight: 600; color: #D33B2E; margin: 0.5rem 0;">{{ orderInfo?.payProductTotal }}{{ orderInfo?.cardPointTypeUnit || '点' }}</span>
        </div>
      </div>
      <div class="confirm-order-tip">该商品不支持无理由退换，为了您的兑换体验，请仔细挑选~</div>
    </div>
    <!-- 用户切换收货地址：唯一允许变更快照的入口。配送方式 / 时间 / 门店在结算页只读，
         如需变更须返回详情页重新走 prePurchase；购物车结算的配送方式由加购阶段决定。 -->
    <select-address v-if="showSelectAddress" :address-list="addressList" @closed="closedadd"
      @seleceAddressItem="seleceAddressItem"> </select-address>
    <scarce-type v-if="ScarceShow" @closed="closedScarce" @selectScarceItem="selectScarceItem"></scarce-type>
    <!-- 底部 -->
    <Footer :orderInfo="orderInfo" :settlement-key="queryCode" :can-by="deliveryFlag && addressReady"></Footer>
  </div>
</template>

<script>
/**
 * 结算页职责（与后端契约对齐）：
 * - 入口：路由 query.code 指向 Redis 中的结算快照（settlementKey）。
 * - 快照来源有二：
 *     1) prePurchase（立即购）— 后端写入时 recalculated=true，已含地址 + 运费，结算页不再自动重算；
 *     2) prepareCheckoutSnapshot（购物车结算）— 后端写入时 recalculated=false，结算页必须先
 *        getMyAddress + recalculateCheckoutSnapshot 把地址/运费补齐，否则 submitOrderInfo 会拒绝。
 * - 用户唯一允许变更的项：收货地址 与 缺货策略；配送方式 / 时间 / 门店在结算页只读。
 *   切换地址 → recalculateCheckoutSnapshot 重算并回写同一 settlementKey。
 * - 点结算 → /productOrderInfo {settlementKey, outOfStockStatus, consumptionType}，后端原子 GET+DEL 快照建单。
 */
import { Toast } from "vant";
import OrderHead from "../../components/order/OrderHead.vue";
import ScarceType from "../../components/order/ScarceType.vue";
import SelectAddress from "../../components/goods/SelectAddress.vue";
import Footer from "./Footer.vue";
export default {
  name: "confirmOrder",
  data() {
    return {
      // 1=顶部可改址；0=顶部只读展示（蛋糕商家配送等，与订单详情一致）
      showAddressBar: '1',
      queryCode: '',
      userId: '',
      freecaId: '',
      orderInfo: {},
      // 地址变更弹窗
      showSelectAddress: false,
      addressList: [],
      // 是否支持配送（任一子单 deliveryFlag=false 即为 false，下单按钮置灰）
      deliveryFlag: true,
      // 地址 + 运费 是否就绪（快照 recalculated=true 或 recalc 成功后置 true）
      addressReady: false,
      // 缺货策略
      scarceStr: '与我联系',
      ScarceShow: false,
    };
  },
  components: { Footer, OrderHead, SelectAddress, ScarceType },
  computed: {
    // 整单是否都是"无需物流"商品（影响顶部运费栏的展示）
    isLogisticOnly() {
      if (!this.orderInfo?.productSubOrderList) return false;
      return this.orderInfo.productSubOrderList.every(item =>
        item.shipType === 'logistic' || item.ship_type === 'logistic'
      );
    },
    groupIdMap() {
      const map = {};
      (this.orderInfo?.groups || []).forEach(g => {
        if (g && g.id != null) map[String(g.id)] = g;
      });
      return map;
    },
    // groupSeq → group 反查（子单可能只挂 groupSeq）
    groupSeqMap() {
      const map = {};
      (this.orderInfo?.groups || []).forEach(g => {
        if (g && g.groupSeq != null) map[g.groupSeq] = g;
      });
      return map;
    },
    /** 存在多组时底部展示「运费合计」与组内「运费」行 */
    hasMultipleShipGroups() {
      return (this.orderInfo?.groups || []).length > 1;
    },
    orderTotalShipLabel() {
      return this.hasMultipleShipGroups ? '运费合计' : '总运费';
    },
    /**
     * 按 groups.groupSeq 排序聚合子单；组内顺序与 productSubOrderList 一致。
     * 匹配优先 groupId === group.id，其次 groupSeq === group.groupSeq。
     * 未匹配到任何一条 group 的子单：一子单一卡（不按 groupSeq 合并），避免无分组元数据时误把多条捏成一组。
     */
    displayProductGroups() {
      const list = this.orderInfo?.productSubOrderList;
      if (!list || !list.length) return [];
      const groups = this.orderInfo?.groups || [];
      if (!groups.length) {
        return list.map(item => ({ group: null, items: [item] }));
      }
      const sorted = [...groups].sort(
        (a, b) => (Number(a.groupSeq) || 0) - (Number(b.groupSeq) || 0)
      );
      const used = new Array(list.length).fill(false);
      const out = [];
      sorted.forEach(g => {
        const items = [];
        list.forEach((it, idx) => {
          if (used[idx]) return;
          const byId = g.id != null && it.groupId != null && String(it.groupId) === String(g.id);
          const bySeq = it.groupSeq != null && String(it.groupSeq) === String(g.groupSeq);
          if (byId || bySeq) {
            items.push(it);
            used[idx] = true;
          }
        });
        if (items.length) out.push({ group: g, items });
      });
      list.forEach((it, idx) => {
        if (!used[idx]) {
          const gm =
            (it.groupId != null ? this.groupIdMap[String(it.groupId)] : null) ||
            (it.groupSeq != null ? this.groupSeqMap[it.groupSeq] : null) ||
            null;
          out.push({ group: gm, items: [it] });
        }
      });
      return out;
    },
    /** type=1 可点击改址；type=0 只读展示快照地址 */
    addressHeadReadonly() {
      return this.showAddressBar !== '1';
    },
    hasCheckoutDisplayAddress() {
      const line = (this.getAddress() || '').trim();
      if (line) return true;
      const addr = this.orderInfo?.consigneeAddress;
      if (addr == null || addr === undefined) return false;
      const s = String(addr).trim();
      if (!s) return false;
      const lower = s.toLowerCase();
      return lower !== 'null' && lower !== 'undefined';
    },
    /** 是否存在需展示收货地址的子单（非门店自提、非无需物流） */
    orderNeedsDeliveryAddress() {
      const list = this.orderInfo?.productSubOrderList || [];
      return list.some((it) => {
        const t = it.shipType || it.ship_type;
        return t && t !== 'logistic' && t !== 'shop';
      });
    },
    /** 顶部固定地址栏：快递可改址；蛋糕等只读且有地址时同样展示 */
    showTopAddressHead() {
      if (this.showAddressBar === '1') return true;
      return this.hasCheckoutDisplayAddress && this.orderNeedsDeliveryAddress;
    },
  },
  mounted() {
    this.initState();
  },
  methods: {
    showGroupShipFeeRow(group) {
      return !!(group && (this.orderInfo?.groups || []).length > 1);
    },
    groupDeliveryUnsupported(gBlock) {
      return (gBlock.items || []).some(it => it.deliveryFlag === false);
    },
    /** delivery_text，挂在组上返回结算页 */
    groupDeliveryText(gBlock) {
      const g = gBlock && gBlock.group;
      if (!g) return '';
      const raw = g.deliveryText != null ? g.deliveryText : g.delivery_text;
      if (raw == null || raw === '') return '';
      const s = String(raw).trim();
      return s || '';
    },
    groupAllLogistic(gBlock) {
      const arr = gBlock.items || [];
      if (!arr.length) return false;
      return arr.every(it => (it.shipType || it.ship_type) === 'logistic');
    },
    /** 组内用于配送方式/地址/时间的代表子单：首个非「无需物流」的，否则第一个 */
    groupFooterForDelivery(gBlock) {
      const items = gBlock.items || [];
      const hit = items.find(it => {
        const t = it.shipType || it.ship_type;
        return t && t !== 'logistic';
      });
      return hit || items[0] || {};
    },
    formatShipAmount(v) {
      if (v === null || v === undefined || v === '') return '0';
      const n = Number(v);
      if (Number.isNaN(n)) return String(v);
      return n % 1 === 0 ? String(n) : String(Math.round(n * 100) / 100);
    },

    /* ============== 缺货策略 ============== */
    selectScarce() { this.ScarceShow = true; },
    closedScarce() { this.ScarceShow = false; },
    selectScarceItem(item) {
      this.scarceStr = item.name;
      this.orderInfo.outOfStockStatus = item.status;
      this.ScarceShow = false;
    },

    /* ============== 地址变更（唯一允许变更快照的入口） ============== */
    editAddress() { this.showSelectAddress = true; },
    closedadd(val) { this.showSelectAddress = val; },
    async seleceAddressItem(item) {
      // 先更新本地展示（字段含义与后端 recalculateCheckoutSnapshot 一致，避免区县重复闪烁）
      this.applyAddressFromItem(item);
      this.showSelectAddress = false;
      await this.changeAddress();
    },

    /**
     * 地址展示：省 addressCname + 市 addressQname + 区 addressPname + 详细 consigneeAddress。
     * consigneeAddress 仅含「详细地址 + 门牌」，勿再拼区县（否则 getAddress 会重复区县）。
     */
    applyAddressFromItem(item) {
      if (!item) return;
      this.orderInfo.addressId = item.id;
      this.orderInfo.consigneeName = item.recipient;
      this.orderInfo.consigneePhone = item.recipientMobile;
      this.orderInfo.addressCname = item.addressCname;
      this.orderInfo.addressQname = item.addressQname;
      this.orderInfo.addressPname = item.addressPname;
      this.orderInfo.consigneeAddress = (item.address || '') + (item.houseNum || '');
    },

    /**
     * 调 recalculateCheckoutSnapshot 把当前 addressId 同步到快照。
     * 成功后 orderInfo 整体替换为最新快照（含运费、deliveryFlag、recalculated=true）。
     */
    async changeAddress() {
      this.addressReady = false;
      Toast.loading({ message: '正在更新配送与费用…', forbidClick: true, duration: 0 });
      if (!this.queryCode || !this.orderInfo.addressId) {
        this.deliveryFlag = false;
        Toast.clear();
        this.$Toast('结算失败，请返回重试');
        return;
      }
      try {
        const res = await this.$api.recalculateCheckoutSnapshot(this.queryCode, this.orderInfo.addressId);
        if (res.code !== 0 || !res.data) {
          this.deliveryFlag = false;
          this.$Toast(res.msg || '结算失败，请稍后重试');
          return;
        }
        const outOfStockStatus = this.orderInfo?.outOfStockStatus || '0';
        this.orderInfo = res.data;
        this.orderInfo.outOfStockStatus = outOfStockStatus;
        this.refreshDeliveryFlag();
        this.addressReady = true;
      } catch (e) {
        this.deliveryFlag = false;
        this.$Toast((e && e.msg) || '网络异常，请稍后重试');
      } finally {
        Toast.clear();
      }
    },

    /**
     * 拉取地址列表并选定默认/上次结算地址 → 触发一次 recalculateCheckoutSnapshot。
     * 仅当快照尚未就绪时（购物车结算 recalculated !== true）才会被调用。
     */
    async getMyAddress() {
      this.addressReady = false;
      try {
        const res = await this.$api.getAddress(this.userId);
        if (res.code == 1) {
          this.$Toast(res.msg);
          return;
        }
        this.addressList = res.data || [];
        if (this.addressList.length === 0) {
          this.addressTag();
          return;
        }
        const el = (this.orderInfo.addressId &&
            this.addressList.find(a => String(a.id) === String(this.orderInfo.addressId))) ||
            this.addressList.find(e => e.defaultFlag == '1') ||
            this.addressList[0];
        this.applyAddressFromItem(el);
        await this.changeAddress();
      } catch (e) {
        this.addressReady = false;
        this.deliveryFlag = false;
        this.$Toast((e && e.msg) || '地址加载失败');
      }
    },
    addressTag() {
      this.$Dialog.confirm({
        title: '提示',
        message: '请先设置收货地址',
        confirmButtonText: '去设置',
      }).then(() => {
        this.$router.push('/EditAddress');
      }).catch(() => { /* on cancel */ });
    },

    /* ============== 展示辅助 ============== */
    getAddress() {
      return (this.orderInfo.addressCname || '')
        + (this.orderInfo.addressQname || '')
        + (this.orderInfo.addressPname || '')
        + (this.orderInfo.consigneeAddress || '');
    },
    /** 顶部 OrderHead：优先省市区+详细；快照仅 consigneeAddress 时回退整段 */
    getDisplayAddress() {
      const composed = (this.getAddress() || '').trim();
      if (composed) return composed;
      return (this.orderInfo?.consigneeAddress || '').trim();
    },
    getPrice(num, price) {
      const amount = Number(num) * Number(price);
      if (!Number.isFinite(amount)) return '0';
      return amount.toFixed(2).replace(/\.?0+$/, '');
    },
    formatChargeAmount(amount) {
      const num = Number(amount || 0);
      return Math.round(num * 100) / 100;
    },
    ifShoow(val) {
      const t = val?.shipType || val?.ship_type;
      return t === 'shop';
    },
    getSendType0(val) {
      const t = val?.shipType || val?.ship_type;
      if (t === 'delivery') return '商家配送';
      if (t === 'shop') return '门店自提';
      if (t === 'same') return '快递配送';
      if (t === 'logistic') return '无需物流';
      return '';
    },
    getSendType1(val) {
      const t = val?.shipType || val?.ship_type;
      const d = val?.shipDate || val?.ship_date;
      if (!t || !d) return '';
      return t === 'shop' ? '自提时间' : '配送时间';
    },
    getSendType2(val) {
      if (val?.shipType && val?.shipDate) {
        return (val.shipDate || '') + ' ' + (val.shipTimeText || '');
      }
      if (val?.ship_type && val?.ship_date) {
        return this.$moment(val.ship_date).format('MM月DD日') + ' ' + (val.ship_time_text || '');
      }
      return '';
    },

    /* ============== 主流程 ============== */
    initState() {
      const userInfo = localStorage.getItem('userInfo');
      this.userId = userInfo ? JSON.parse(userInfo).id : '';
      this.freecaId = localStorage.getItem('cardId');
      const queryData = this.$route.query;
      if (queryData) {
        const { code, type } = queryData;
        this.queryCode = code;
        // type 在路由中可能是 number / string，统一规范
        this.showAddressBar = typeof type === 'number' ? String(type) : type;
        this.loadSnapshot(code);
      }
    },

    /**
     * 加载快照 → 根据 recalculated 决定是否强制重算。
     * - recalculated === true（prePurchase 写入）→ 直接展示，不再二次重算（避免无谓的三方配送规则请求）
     * - recalculated !== true（prepareCheckoutSnapshot 半成品）→ 强制 getMyAddress + recalc
     * - showAddressBar='0'（蛋糕商家配送等）→ 顶部只读地址栏，沿用快照，不允许改址
     */
    async loadSnapshot(code) {
      if (!code) return;
      this.queryCode = code;
      Toast.loading({ message: '加载结算信息…', forbidClick: true, duration: 0 });
      try {
        const res = await this.$api.getCheckoutSnapshot(code);
        if (res.code !== 0) {
          this.$Toast(res.msg || '结算信息已失效，请重新下单');
          this.backOrReplace();
          return;
        }
        this.orderInfo = res.data || {};
        this.orderInfo.outOfStockStatus = '0';

        const needRecalc = this.showAddressBar === '1' && this.orderInfo.recalculated !== true;
        if (needRecalc) {
          Toast.loading({ message: '正在匹配地址与运费…', forbidClick: true, duration: 0 });
          await this.getMyAddress();
        } else {
          this.addressReady = true;
          if (this.showAddressBar === '1') {
            try {
              const addrRes = await this.$api.getAddress(this.userId);
              this.addressList = (addrRes && addrRes.code !== 1 && addrRes.data) || [];
            } catch (_) { /* 拉取失败不阻塞 */ }
          }
        }
        this.refreshDeliveryFlag();
      } catch (e) {
        this.$Toast((e && e.msg) || '结算信息加载失败');
        this.backOrReplace();
      } finally {
        Toast.clear();
      }
    },

    refreshDeliveryFlag() {
      let ok = !!this.orderInfo;
      (this.orderInfo?.productSubOrderList || []).forEach(element => {
        if (!element.deliveryFlag) ok = false;
      });
      this.deliveryFlag = ok;
    },

    backOrReplace() {
      if (window.history.length > 1) {
        this.$router.go(-1);
      } else {
        this.$router.replace({ name: 'myCart' });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/order-card.scss";

.confirm-order-warpper {
  --checkout-footer-h: 3rem;
  --confirm-h-margin: var(--order-h-margin, 0.8rem);
  --confirm-block-gap: var(--order-block-gap, 0.55rem);
  height: 100vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  background-color: #f8f8f8;
  font-size: 0.8125rem;
  color: #333;
  box-sizing: border-box;
}

.confirm-order-address-fixed {
  flex: 0 0 auto;
  padding-top: var(--confirm-h-margin);
}

.confirm-order-scroll {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  margin-top: 0;
  padding-top: var(--confirm-h-margin);
  padding-bottom: calc(var(--checkout-footer-h) + env(safe-area-inset-bottom, 0px));
}

/* 有地址栏时：顶距由地址区承担，列表与地址区间距=卡片间距 */
.confirm-order-address-fixed + .confirm-order-scroll {
  padding-top: 0;
  margin-top: var(--confirm-block-gap);
}

.confirm-order-tip {
  color: #d33b2e;
  font-size: 0.8rem;
  margin: var(--confirm-block-gap, 0.55rem) var(--confirm-h-margin, 0.8rem);
  line-height: 1.4;
}

.confirm-order-warpper {
  .confirm-order-content {
    padding: 0;
    background-color: white;
    border-radius: 0.8rem;
    margin: 0 var(--confirm-h-margin);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  }

  /* 与规格弹窗 index.scss 字号阶梯对齐 */
  .textTitle {
    font-size: 0.9375rem;
    margin-bottom: 0.3rem;
  }

  .textcontext {
    font-size: 0.8125rem;
    margin-bottom: 0.28rem;
  }

  .label-muted {
    font-size: 0.8125rem;
  }

  .product-amount {
    font-size: 1.05rem;
  }

  .product-qty {
    font-size: 0.75rem;
  }

  .img {
    width: 5rem;
    height: 5rem;
  }

  .charge-list {
    font-size: 0.8125rem;
  }

  .charge-list-title {
    font-size: 0.8125rem;
  }

  .charge-name {
    font-size: 0.8125rem;
  }

  .charge-qty,
  .charge-amount {
    font-size: 0.75rem;
  }

  .group-delivery-note-under-method {
    font-size: 0.7rem;
  }

  .sendjcsb {
    font-size: 0.8125rem;
  }
}

.bgc {
  background-color: #fff;
  border-radius: 0.8rem;
  margin: 0 var(--confirm-h-margin, 0.8rem);
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
  transition: all 0.3s ease;
  
  &:hover {
    box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  }
}

.paytype {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-bottom: 1px dashed #e0e0e0;
  padding: 0 0 1rem 0.5rem;
  margin-top: 0.5rem;
  align-items: center;
}

.sendjcsb {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  font-size: 1rem;
  padding: 0.5rem 0;
  align-items: center;
  
  &:hover {
    background-color: #fafafa;
  }
}

/* 蛋叔 V2 附件明细（结算页） */
.charge-list {
  padding: 0.5rem 0;
  font-size: 0.85rem;
}

.charge-list-title {
  color: #888;
  margin: 0.3rem 0;
}

.charge-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  line-height: 1.6;
  padding: 0.1rem 0;
}

.charge-name {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-right: 0.4rem;
  color: #555;
}

.charge-qty {
  color: #888;
  margin-right: 0.6rem;
  min-width: 2rem;
  text-align: right;
}

.charge-amount {
  color: #d33b2e;
  min-width: 4rem;
  text-align: right;
}

.cai {
  width: 100%;
}

.textTitle {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  color: #333;
  margin-bottom: 0.35rem;
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.35;
}

.textcontext {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
  color: #666;
  margin-bottom: 0.35rem;
  font-size: 0.9rem;
  line-height: 1.35;
}

.product-spec {
  color: #555;
}

.product-taste {
  color: #666;
}

.scarcegoods {
  background-color: white;
  border-radius: 0.8rem;
  margin: 0 0.8rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 1.1rem;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
}

.img {
  width: 5rem;
  height: 5rem;
  border-radius: 0.8rem;
  object-fit: cover;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.flex {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
}

.product-head {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
}

.product-main {
  flex: 1 1 auto;
  min-width: 0;
  width: 100%;
}

.product-body {
  flex: 1 1 auto;
  min-width: 0;
  min-height: 5rem;
  display: flex;
  flex-direction: column;
}

.product-price-col {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: flex-end;
  margin-top: auto;
  padding-bottom: 0.12rem;
}

.product-qty {
  font-size: 0.82rem;
  font-weight: 500;
  color: #888;
  margin-left: 0.2rem;
}

.product-amount {
  font-size: 1.14rem;
  font-weight: 600;
  color: #d33b2e;
  line-height: 1.2;
}

.product-price-line {
  display: flex;
  flex-direction: row;
  align-items: baseline;
  justify-content: flex-end;
  width: 100%;
  gap: 0.1rem;
  white-space: nowrap;
}

.order-card-wrap {
  margin-bottom: var(--confirm-block-gap, 0.55rem);
}

.order-card-wrap:first-child {
  margin-top: 0;
}

.order-group-card,
.order-summary-card {
  padding: 0.65rem 0.75rem;
}

.order-summary-card {
  margin-top: var(--confirm-block-gap, 0.55rem);
}

.product-group-segment.is-not-first-product {
  border-top: 1px solid #f0f0f0;
  margin-top: 0.55rem;
  padding-top: 0.55rem;
}

.group-delivery-block {
  border-top: 1px solid #ededed;
  margin-top: 0.5rem;
  padding-top: 0.35rem;
}

/* 配送方式下一行小字（与规格弹窗 van-cell #label 同类，不配「配送说明」大标签） */
.group-delivery-note-under-method {
  font-size: 0.72rem;
  line-height: 1.4;
  color: #969799;
  padding: 0 0 0.4rem 0;
  margin-top: -0.2rem;
  word-break: break-word;
  white-space: pre-wrap;
}

.sendjcsb--padded {
  padding: 0.45rem 0;
}

.label-muted {
  color: #888;
  word-break: keep-all;
  min-width: 4rem;
}

.label-muted--wide {
  min-width: 5rem;
}

.group-undeliverable-banner {
  margin-top: 0.35rem;
  padding: 0.55rem 0.65rem;
  background: #fff5f5;
  border-radius: 0.4rem;
  border: 1px solid rgba(211, 59, 46, 0.2);
}

.group-undeliverable-title {
  margin: 0;
  font-size: 0.85rem;
  font-weight: 600;
  color: #d33b2e;
  line-height: 1.4;
}

.text-fee {
  color: #d33b2e;
  font-weight: 600;
}

.text-free-ship {
  color: #06a77d;
}

.group-ship-fee-value {
  text-align: right;
  flex: 1;
  min-width: 0;
}

.recharge-hint {
  font-size: 0.8rem;
  justify-content: flex-start;
  color: #666;
  padding: 0.25rem 0 0.5rem;
}

.bordered-top {
  border-top: 1px solid #ededed;
  margin-top: 0.5rem;
  padding-top: 0.35rem;
}

.charge-list--bordered {
  border-top: 1px solid #ededed;
  margin-top: 0.5rem;
  padding-top: 0.5rem;
}
</style>
